<script>
export default {
  inheritAttrs: true,
  model: {
    event: 'update',
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: [String, undefined],
      default: undefined,
    },
    name: {
      type: String,
      default: 'name',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    hasError: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    max: {
      type: Number,
      default: undefined,
    },
  },
}
</script>

<template>
  <div class="text-left mb-3">
    <label v-if="label" :for="value">{{ label }}</label>
    <div class="input-group" :class="$style.input">
      <input
        :placeholder="placeholder"
        class="form-control"
        :type="type"
        :class="{ 'is-invalid': hasError }"
        :value="value"
        :name="name"
        :maxlength="max"
        @input="$emit('update', $event.target.value)"
        v-on="$listeners"
      />
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.input {
  input {
    @extend %typography-small;

    display: block;
    width: 100%;
    padding: $size-input-padding-vertical $size-input-padding-horizontal;
    margin-bottom: $size-grid-padding;
    line-height: 1;
    border: $size-input-border solid $color-input-border;
    border-radius: $size-input-border-radius;
  }
}
</style>
